import { ContactInfoActions, ContactInfoActionTypes } from '../actions/actions-contact';

export interface State {
  email: any;
  emailResponse: any;
  isLoading: boolean;
}

const initialState: State = {
  email: {},
  emailResponse: null,
  isLoading: false
};

/* eslint-disable */
export function reducer(state = initialState, action: ContactInfoActions): State {
  switch (action.type) {
    case ContactInfoActionTypes.SendEmail: {
      return { ...state, email: action.payload };
    }

    case ContactInfoActionTypes.SendEmailResponse: {
      return { ...state, emailResponse: action.payload };
    }

    default:
      return state;
  }
}
